const OptionsAdapter = (data) => {
  const findOptionKey = (
    firstOption,
    listOfCustomKeys,
  ) => Object.keys(firstOption).find((optionKey) => listOfCustomKeys.includes(optionKey));

  const hasCustomLabel = (options) => {
    if (!options || options.error) {
      return;
    }

    const custom = ["title"];

    const firstOption = options[0];
    // only test the first option form array because they should all be the same
    return findOptionKey(firstOption, custom);
  };

  const hasCustomValues = (options) => {
    if (!options || options.error) {
      return;
    }

    const custom = ["web_id", "title"];
    const firstOption = options[0];
    // only test the first option form array because they should all be the same
    return findOptionKey(firstOption, custom);
  };

  const addLabelToOptions = () => {
    if ((!data || !data?.length >= 1) || data.error) {
      return;
    }

    const customValue = hasCustomValues(data);
    const customLabel = hasCustomLabel(data);

    data.forEach((option) => {
      if (!option.label) {
        if (!customLabel) {
          option.label = option.name;
        } else {
          option.label = option[customLabel];
        }
      }

      if (!option.value) {
        if (!customValue) {
          option.value = option.name;
        } else {
          // this is for options that return and require a particular id such as MailChimp
          option.value = option[customValue];
        }
      }
    });

    return data;
  };

  const defaultOption = (value, customLabel) => {
    if (!value) {
      return;
    }

    return {
      value,
      label: customLabel || value,
    };
  };

  return {
    addLabelToOptions,
    defaultOption,
  };
};

export default OptionsAdapter;
